<script setup lang="ts">
import { onMounted, ref } from 'vue';

import BaseBodyText from '@/components/base/typography/BaseBodyText.vue';
import { useFeatureFlags } from '@/composables/useFeatureFlags';
import { useLocalStorage } from '@/composables/useLocalStorage';

const { flags } = useFeatureFlags();

const surveyOpened = ref<boolean>(false);

onMounted(() => {
  surveyOpened.value = !!useLocalStorage('orderReceiptSurvey').get<boolean>('opened');
});

function handleClick() {
  useLocalStorage('orderReceiptSurvey').set<boolean>('opened', true);
}
</script>

<template>
  <a
    v-if="!surveyOpened && flags.postCheckoutSurvey"
    class="flex items-center w-full px-4 py-3 transition-all border-none rounded-md shadow-md cursor-pointer hover:no-underline bg-nuts-amber-300 text-black-link hover:brightness-95"
    href="https://surveys.delighted.com/c/u/62H6FycI"
    role="link"
    target="_blank"
    @click="handleClick"
  >
    <BaseBodyText>Rate your experience with Nuts.com <u>here</u></BaseBodyText>
  </a>
</template>

<style scoped>
.text-black-link {
  @apply text-black;
}
</style>
